<div class="switch">
  <label>
    <input 
        type="checkbox" 
        [(ngModel)]="activity.model.noScheduleAllowed" 
    />
    Allow "No Schedule" Inspections
  </label>
</div>

<div class="form-group mt-0 mb-5">
  <label class="bmd-label-floating" for="inspectionType">
    Inspection Type
  </label>
  <input
    type="text"
    class="form-control"
    name="inspectionType"
    [(ngModel)]="activity.model.inspectionType"
  />
</div>

<h4>
  Request Inspection Step
</h4>

<div class="switch">
  <label>
    <input
      id="sendOnRequestedEmail"
      type="checkbox"
      [(ngModel)]="activity.model.sendOnRequestedEmail"
    />
    Send an email when an inspection is requested?
  </label>
</div>

<wm-email-editor
  *ngIf="activity.model.sendOnRequestedEmail"
  [activity]="activity"
  [emailModel]="activity.model.onRequestedEmailModel"
  [workflow]="workflow"
  [form]="onRequestedEmailForm"
  [loadFull]="loadFull"
  [hideHeader]="true"
></wm-email-editor>

<wm-form-activity-editor
    id="request"
    [activity]="requestStepActivity"
    [form]="requestForm"
    [workflow]="workflow"
    (saved)="requestStepSaved($event)"
></wm-form-activity-editor>

<h4>
  Schedule Inspection Step
</h4>

<div class="form-group">
  <label class="bmd-label-floating" for="scheduleInspectionresponsibleRole">
    Schedule Inspection Responsible Role
  </label>
  <select
    name="scheduleInspectionresponsibleRole"
    [(ngModel)]="activity.model.scheduleStepResponsibleRoleId"
    class="form-control"
  >
    <option
      *ngFor="let scheduleRole of availableScheduleRoles"
      [value]="scheduleRole.id"
    >
      {{ scheduleRole.name }}
    </option>
  </select>
</div>

<div class="switch">
  <label>
    <input
      id="sendOnScheduledEmail"
      type="checkbox"
      [(ngModel)]="activity.model.sendOnScheduledEmail"
    />
    Send an email when an inspection is scheduled?
  </label>
</div>

<wm-email-editor
  *ngIf="activity.model.sendOnScheduledEmail"
  [activity]="activity"
  [emailModel]="activity.model.onScheduledEmailModel"
  [workflow]="workflow"
  [form]="onScheduledEmailForm"
  [loadFull]="loadFull"
  [hideHeader]="true"
></wm-email-editor>

<div class="switch" *ngIf="activity.model.sendOnScheduledEmail">
  <label>
    <input
      id="attachScheduledCalendarEvent"
      type="checkbox"
      [(ngModel)]="activity.model.attachScheduledCalendarEvent"
    />
    Attach calendar event?
  </label>
</div>

<form
  [formGroup]="onScheduledCalendarForm"
  *ngIf="activity.model.sendOnScheduledEmail && activity.model.attachScheduledCalendarEvent"
>
  <div class="card mt-2 mb-3">
    <div class="card-header">
      <strong>Calendar Event</strong>
    </div>
    <div class="card-body">
      <p class="text-muted mb-3">
        Calendar event date and time are determined by the scheduled inspection
        date and time Data Entity <code>SCHEDULE_SDL_USER</code>.
      </p>

      <div class="form-row">
        <div class="col">
          <wm-data-entity-autocomplete
            [types]="['list-data', 'free-form-text']"
            [form]="onScheduledCalendarForm"
            [model]="activity.model.onScheduledCalendarEvent.location"
            [activity]="activity"
            id="sched_appt_location"
            [required]="true"
            controlName="sched_appt_location"
            [title]="'Location'"
            [workflow]="workflow"
            placement="left"
            [serverValidator]="workflowSvc.validateEmailFields"
            (valueUpdate)="activity.model.onScheduledCalendarEvent.location = $event"
          >
          </wm-data-entity-autocomplete>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <div class="switch">
            <label>
              <input
                type="checkbox"
                formControlName="sched_allDay"
                id="sched_allDay"
                [(ngModel)]="activity.model.onScheduledCalendarEvent.allDay"
              />
              All Day Event
            </label>
          </div>
        </div>
      </div>
      <div class="form-row" *ngIf="!activity.model.onScheduledCalendarEvent.allDay">
        <div class="col">
          <wm-data-entity-autocomplete
            [types]="['numeric-data']"
            [form]="onScheduledCalendarForm"
            [model]="activity.model.onScheduledCalendarEvent.durationMinutes"
            id="sched_appt_duration"
            [activity]="activity"
            [required]="!activity.model.onScheduledCalendarEvent.allDay"
            controlName="sched_appt_duration"
            [title]="'Duration (minutes)'"
            [workflow]="workflow"
            placement="left"
            [serverValidator]="workflowSvc.validateEmailFields"
            (valueUpdate)="activity.model.onScheduledCalendarEvent.durationMinutes = $event"
          >
          </wm-data-entity-autocomplete>
        </div>
      </div>
    </div>
  </div>
</form>

<wm-form-activity-editor
    id="schedule"
    [activity]="scheduleStepActivity"
    [form]="scheduleForm"
    [workflow]="workflow"
    (saved)="scheduleStepSaved($event)"
></wm-form-activity-editor>

<h4>
  Complete Inspection Step
</h4>

<div *ngIf="!canEditCompleteStep" class="text-warning">
  <i>
    You do not have permission to edit the design of the Complete Inspection
    Step.
  </i>
</div>

<div *ngIf="canEditCompleteStep">
    <div class="form-group">
        <label class="bmd-label-floating" for="completeInspectionresponsibleRole">
            Complete Inspection Responsible Role
        </label>
        <select
            name="completeInspectionresponsibleRole"
            [(ngModel)]="activity.model.completeStepResponsibleRoleId"
            class="form-control"
        >
            <option *ngFor="let completeRole of availableCompleteRoles" [value]="completeRole.id">
                {{ completeRole.name }}
            </option>
        </select>
    </div>
    
    <wm-form-activity-editor
        id="complete"
        [activity]="completeStepActivity"
        [form]="completeForm"
        [workflow]="workflow"
        [extraToolButtons]="noScheduleOnlyToolButtons"
        (saved)="completeStepSaved($event)"
    ></wm-form-activity-editor>
</div>
